import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Shield } from 'lucide-react';

export default function AGB() {
  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Link to="/login">
            <Button variant="ghost" size="icon">
              <ArrowLeft className="h-5 w-5" />
            </Button>
          </Link>
          <div className="flex items-center gap-3">
            <img src="/firecheck-logo.png" alt="FireCheck" className="h-12 w-12 rounded-lg object-contain" />
            <div>
              <h1 className="font-heading font-bold text-2xl">FireCheck</h1>
              <p className="text-sm text-muted-foreground">Allgemeine Geschäftsbedingungen</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none space-y-6">
          <section className="p-6 rounded-lg bg-card border border-border">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Shield className="h-5 w-5 text-primary" />
              Allgemeine Geschäftsbedingungen (AGB)
            </h2>
            <p className="text-sm text-muted-foreground mb-4">
              Stand: Januar 2026 | Gültig für die Schweiz
            </p>

            <div className="space-y-6 text-sm">
              <div>
                <h3 className="font-semibold text-base mb-2">1. Geltungsbereich</h3>
                <p className="text-muted-foreground">
                  Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der FireCheck-Applikation 
                  zur Durchführung von Brandschutzkontrollen und -abnahmen. Mit der Nutzung der Applikation 
                  akzeptiert der Benutzer diese AGB vollumfänglich.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">2. Leistungsbeschreibung</h3>
                <p className="text-muted-foreground">
                  FireCheck ist eine Softwarelösung zur Unterstützung bei der Durchführung von 
                  Brandschutzkontrollen. Die Applikation stellt Checklisten, Dokumentationsmöglichkeiten 
                  und Berichtsfunktionen zur Verfügung.
                </p>
              </div>

              <div className="p-4 rounded-lg bg-amber-500/10 border border-amber-500/20">
                <h3 className="font-semibold text-base mb-2 text-amber-500">3. Haftungsausschluss</h3>
                <div className="text-amber-200/80 space-y-2">
                  <p>
                    <strong>3.1 Checklisten:</strong> Die in der Applikation enthaltenen Checklisten sind 
                    <strong> nicht abschliessend</strong> und dienen lediglich als Orientierungshilfe. 
                    Sie erheben keinen Anspruch auf Vollständigkeit und müssen vom Benutzer eigenverantwortlich 
                    ergänzt und an die jeweiligen Gegebenheiten angepasst werden.
                  </p>
                  <p>
                    <strong>3.2 Keine Haftung:</strong> Der Betreiber von FireCheck übernimmt 
                    <strong> keine Haftung</strong> für Fehler, Unvollständigkeiten oder Mängel in den 
                    bereitgestellten Checklisten, Vorlagen oder generierten Berichten. Die Verantwortung 
                    für die korrekte und vollständige Durchführung der Brandschutzkontrolle liegt 
                    ausschliesslich beim Benutzer.
                  </p>
                  <p>
                    <strong>3.3 Fachliche Kompetenz:</strong> Die Nutzung der Applikation ersetzt nicht 
                    die erforderliche fachliche Qualifikation des Prüfers. Der Benutzer ist verpflichtet, 
                    über die notwendigen Kenntnisse und Bewilligungen für die Durchführung von 
                    Brandschutzkontrollen zu verfügen.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">4. Datenschutz</h3>
                <p className="text-muted-foreground">
                  Die Verarbeitung personenbezogener Daten erfolgt gemäss dem Schweizerischen 
                  Datenschutzgesetz (DSG) und der Datenschutz-Grundverordnung (DSGVO). Daten werden 
                  ausschliesslich zur Erbringung der vereinbarten Leistungen verwendet und nicht an 
                  Dritte weitergegeben, sofern keine gesetzliche Verpflichtung besteht.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">5. Datenspeicherung</h3>
                <p className="text-muted-foreground">
                  FireCheck ist keine Archivierungslösung. Die erstellten Berichte müssen vom Benutzer 
                  eigenverantwortlich gesichert und archiviert werden. Der Betreiber übernimmt keine 
                  Gewähr für die dauerhafte Verfügbarkeit der Daten in der Applikation.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">6. Geistiges Eigentum</h3>
                <p className="text-muted-foreground">
                  Alle Rechte an der Software, den Inhalten und dem Design von FireCheck verbleiben 
                  beim Betreiber. Eine Vervielfältigung, Verbreitung oder sonstige Nutzung bedarf der 
                  ausdrücklichen schriftlichen Zustimmung.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">7. Verfügbarkeit</h3>
                <p className="text-muted-foreground">
                  Der Betreiber bemüht sich um eine hohe Verfügbarkeit der Applikation, kann jedoch 
                  keine ununterbrochene Erreichbarkeit garantieren. Für Ausfälle oder Unterbrechungen 
                  wird keine Haftung übernommen.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">8. Änderungen der AGB</h3>
                <p className="text-muted-foreground">
                  Der Betreiber behält sich das Recht vor, diese AGB jederzeit zu ändern. Änderungen 
                  werden den Benutzern in geeigneter Form mitgeteilt. Die fortgesetzte Nutzung der 
                  Applikation gilt als Zustimmung zu den geänderten Bedingungen.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">9. Anwendbares Recht und Gerichtsstand</h3>
                <p className="text-muted-foreground">
                  Es gilt ausschliesslich Schweizer Recht unter Ausschluss des UN-Kaufrechts und der 
                  Kollisionsnormen. Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang 
                  mit diesen AGB ist der Sitz des Betreibers im Kanton Wallis, Schweiz.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base mb-2">10. Salvatorische Klausel</h3>
                <p className="text-muted-foreground">
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die 
                  Wirksamkeit der übrigen Bestimmungen unberührt. Anstelle der unwirksamen Bestimmung 
                  gilt eine wirksame Regelung, die dem wirtschaftlichen Zweck der unwirksamen 
                  Bestimmung am nächsten kommt.
                </p>
              </div>
            </div>
          </section>

          <div className="text-center">
            <Link to="/login">
              <Button variant="outline">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Zurück zum Login
              </Button>
            </Link>
          </div>

          <p className="text-center text-xs text-muted-foreground">
            © 2026 FireCheck. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </div>
  );
}
